import { render, staticRenderFns } from "./Socket.vue?vue&type=template&id=b419f8b6"
import script from "./Socket.vue?vue&type=script&lang=ts"
export * from "./Socket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports